import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const ContactContainer = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 2rem 0;
  outline: 0;
  padding: 0;
  position: relative;
  width: 100%;

  ${breakpoint('tablet')`
    padding: 0 2rem;
    width: 60%;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/ContactForm/styledComponents.js